import React from 'react';

import { Row, Col, Button, Input } from 'antd';

import { ReloadOutlined } from '@ant-design/icons';

import '../styles.less';

const { Search } = Input;

const originalPdfFormsHeader = ({ loadData, originalPdfFormsPageRequest, refresh }) => {
  const handleApplySearch = (searchString) => {
    const updatedPageRequest = { ...originalPdfFormsPageRequest };

    updatedPageRequest.filter = {
      searchString: searchString,
    };

    loadData(updatedPageRequest);
  };

  const handleClear = () => {
    const updatedPageRequest = { ...originalPdfFormsPageRequest };

    updatedPageRequest.filter = {};

    loadData(updatedPageRequest);
  };

  const handleSearch = (searchString) => {
    if (searchString) {
      handleApplySearch(searchString);
    } else {
      handleClear();
    }
  };

  return (
    <Row style={{ justifyContent: 'space-between', width: '100%' }}>
      <Col span={3} className="forms-header-title">
        <span style={{ marginRight: '20px', fontWeight: 600 }}>All Forms</span>
      </Col>

      <Col span={20}>
        <Search placeholder="Search by name..." allowClear enterButton onSearch={handleSearch} style={{ width: 300 }} />
      </Col>

      <Col span={1} className="forms-header-actions">
        <Button type="link" title="Refresh" icon={<ReloadOutlined />} onClick={refresh} />
      </Col>
    </Row>
  );
};

export default originalPdfFormsHeader;
